export const environment = {
  apiUrl: 'https://svc.cine.gr',
  adverticalTVUrl: "https://ads-stage.locpush.tv",
  adverticalApiKey: "12345",
  enableAds: false,
  coWatchENV: "https://myaccount-dev.arx.net",
  enableCoWatch: false,
  appVersion: "Prod 2.3.0",
  priceUnit: "€",
  apiKey: "5678",
  production: false,
  playerThemeColor: "11,163,96",
  drm: {
    enable: false,
    server: ""
  },
  features: {
    hasGuest: false,
    hasProfiles: true,
    hasParentalRating: true,
    posterType: "v",
    posterQuality: "original",
    paymentMethods: [2],
    packageDetails: false,
    orderByTitle: false,
    similarCount: 10,
    customHome: false,
    customHomeVal: "",
    navType: 1,
    powerBy: false,
    hasPinProtection: false,
    hasTVLogin: true
  },
  urls: {
    privacy: "https://www.cine.gr/privacy-policy/",
    terms: "https://www.cine.gr/terms/",
    help: "https://www.cine.gr/help/"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
